import React from "react";
import "./buttons.scss";

export const LinkAsActionButtonA = ({
  url,
  children,
  addtlCssClasses = null,
}) => {
  const classes = () => {
    let _classes = "btn pwm-action-button";

    if (addtlCssClasses) {
      _classes += " ";
      _classes += addtlCssClasses;
      return _classes;
    }
  };

  return (
    <a href={url} className={classes()}>
      {children}
    </a>
  );
};

export const ActionButtonA2 = ({
  onClick,
  children,
  type = null,
  disabled = false,
  cssClasses = "btn pwm-action-button",
  id = null,
  testId = null,
  inLineStyle = {},
  addtlCssClasses = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={cssClasses + " " + addtlCssClasses}
      disabled={disabled}
      id={id}
      data-testid={testId}
      style={inLineStyle}
    >
      {children}
    </button>
  );
};
